interface SideNavDividerProps {
  id: string;
}

const SideNavDivider = ({ id }: SideNavDividerProps) => (
  <div
    id={id}
    role='separator'
    aria-hidden='true'
    className='mx-3 border-t border-gray-200 dark:border-secondary-dark-300'
  />
);

export default SideNavDivider;
